(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"));
	else if(typeof define === 'function' && define.amd)
		define("rb_wixui.corvid[LoginSocialBar]", ["lodash"], factory);
	else if(typeof exports === 'object')
		exports["rb_wixui.corvid[LoginSocialBar]"] = factory(require("lodash"));
	else
		root["rb_wixui.corvid[LoginSocialBar]"] = factory(root["_"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE_T9FV__) {
return 